import React from 'react'
import { Spinner } from "reactstrap";

const CustomSpinner = () => {
    return (
        <>
            <Spinner
                as="span"
                variant="light"
                size="sm"
                role="status"
                aria-hidden="true"
                animation="border"
                className='spinner-center'
            />
        </>
    )
}

export default CustomSpinner